'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var arrows = {};

exports.__exports = arrows;
